import { Navigate } from 'react-router'
import CustomRoute from 'components/routing/CustomRoute'
import { Forbidden } from '@totalsoft/rocket-ui'
import ChatContainer from 'features/chat/ChatContainer'
import CustomNotFound from 'components/custom/CustomNotFound'
const { env } = require('utils/env')
const displaySidebar = JSON.parse(env.REACT_APP_WEBCHAT_DISPLAY_SIDEBAR)
const testLoginRoute = env.REACT_APP_IDENTITY_TESTUSERS_TRIGGER_QUERYSTRING

const routes = [
  { path: '/', element: <CustomRoute component={ChatContainer} fullWidth={!displaySidebar} /> },
  { path: '/fullWidth', element: <CustomRoute component={ChatContainer} fullWidth={true} /> },
  { path: '/lite', element: <CustomRoute component={ChatContainer} fullWidth={!displaySidebar} isPrivate={false} isLite={true} /> },
  { path: '/forbidden', element: <Forbidden /> },
  { path: testLoginRoute, element: <Navigate replace to='/' /> },
  { path: '*', element: <CustomNotFound/> }
]

export default routes
